var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-content"},[_c('div',{staticClass:"center-tip"},[_c('span',[_vm._v("请使用支付宝扫码")])])])
}]

export { render, staticRenderFns }